export namespace Intuitive {
  export const companyIds = ['54d0016c-1318-4411-b8f4-f6b66bef0e4f'];
}
